import { Menu } from "antd";
import {
   DashboardOutlined, UserOutlined, TeamOutlined,
   DollarOutlined, CalendarOutlined, CustomerServiceOutlined,
   BarChartOutlined, ProjectOutlined
} from "@ant-design/icons";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import logo from "./image.png";

const Sidebar = ({ collapsed }) => {
   const location = useLocation();
   const navigate = useNavigate();
   const { user } = useContext(AuthContext);

   if (!user) return null;

   const items = [
      {
         key: "/dashboard",
         icon: <DashboardOutlined />,
         label: <Link to="/dashboard">Dashboard</Link>
      },
      {
         key: "/leads",
         icon: <TeamOutlined />,
         label: <Link to="/leads">Leads</Link>
      },
      {
         key: "/followups",
         icon: <CalendarOutlined />,
         label: <Link to="/followups">Follow-ups</Link>
      },
      user?.role === "admin" && {
         key: "/projects",
         icon: <ProjectOutlined />,
         label: <Link to="/projects">Projects</Link>
      },
      {
         key: "/sales",
         icon: <DollarOutlined />,
         label: <Link to="/sales">Sales</Link>
      },
      {
         key: "/reports",
         icon: <BarChartOutlined />,
         label: "Reports"
      },
      user?.role === "admin" && {
         key: "/users",
         icon: <UserOutlined />,
         label: <Link to="/users">Users</Link>
      },
      // user?.role === "admin" && {
      //    key: "/call-logs",
      //    icon: <UserOutlined />,
      //    label: <Link to="/call-logs">Call Logs</Link>
      // },
      // user?.role === "admin" && {
      //    key: "/calldashboard",
      //    icon: <UserOutlined />,
      //    label: <Link to="/calldashboard">Call Dashboard</Link>
      // },
      user?.role === "admin" && {
         key: "ivr",
         icon: <CustomerServiceOutlined />,
         label: "IVR",
         children: [
            {
               key: "/addagent",
               label: <Link to="/addagent">Add Agent</Link>
            },
            {
               key: "/call-logs",
               label: <Link to="/call-logs">Call Logs</Link>
            },
            {
               key: "/calldashboard",
               label: <Link to="/calldashboard">Call Dashboard</Link>
            }
         ]
      }
   ].filter(Boolean);

   return (
      <div className="h-full flex flex-col">
         {/* Logo Section */}
         <div className="h-16 flex items-center justify-center border-b border-gray-100">
            {collapsed ? (
               <div className="w-10 h-10 flex items-center justify-center">
                  <span className="font-bold text-xl">
                     <span className="text-blue-500">M</span>
                     <span className="text-orange-500">V</span>
                  </span>
               </div>
            ) : (
               <div className="flex items-center">
                  <img
                     src={logo}
                     alt="Logo"
                     className="h-10 w-auto object-contain"
                  />
               </div>
            )}
         </div>

         {/* Menu */}
         <Menu
            theme="light"
            mode="inline"
            selectedKeys={[location.pathname]}
            items={items}
            onClick={(e) => navigate(e.key)}
            className="flex-1 border-r-0"
         />
      </div>
   );
};

export default Sidebar;